var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusInsertFoto = function SvgPlusInsertFoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D6E74F",
    d: "M18.416 1.585a1.58 1.58 0 0 1 .464-1.12A1.58 1.58 0 0 1 20.606.12l.012.005a1.59 1.59 0 0 1 .967 1.459q0 .015-.002.029v16.803h16.803l.03-.002c.213 0 .417.043.605.121l.012.006A1.59 1.59 0 0 1 40 20a1.58 1.58 0 0 1-.98 1.464 1.6 1.6 0 0 1-.634.119H21.583v16.803l.002.03c0 .213-.044.418-.121.605l-.006.012a1.581 1.581 0 0 1-2.579.502 1.58 1.58 0 0 1-.462-1.149V21.583H1.614l-.03.002a1.58 1.58 0 0 1-1.12-.465 1.587 1.587 0 0 1 0-2.24 1.58 1.58 0 0 1 1.15-.463h16.804V1.614z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgPlusInsertFoto;